<div class="ps-card ps-gauge-card">
  <div class="ps-card-header">
    <div class="ps-card-heading">
      <span class="ps-card-icon"><ps-outline-icon name="shield-fill"></ps-outline-icon></span>
      <div>
        <h2 class="ps-card-kicker">Readiness</h2>
        <p class="ps-card-sub">Overall project readiness across key dimensions</p>
      </div>
    </div>
    <div class="ps-card-actions">
      <button class="ps-icon-btn" title="Readiness Assessment Download" (click)="downloadFile()"
        *ngIf="readinessSummary.Priorities && readinessOverallComplete > 0">
        <ps-outline-icon name="download"></ps-outline-icon>
      </button>
      <div class="propak-dropdown ps-card-actions__propak" [class.show]="showProPakDropdown">
        <button class="ps-icon-btn propak-dropdown-toggle" title="Open ProPak options"
          (click)="toggleProPakDropdown($event)" [attr.aria-expanded]="showProPakDropdown">
          <ps-outline-icon name="wrench"></ps-outline-icon>
          <fa-icon [icon]="faChevronDown" class="propak-caret"></fa-icon>
        </button>
        <div class="dropdown-menu propak-dropdown-menu" [class.show]="showProPakDropdown" role="menu">
          <button type="button" class="dropdown-item" role="menuitem" (click)="launchProPak()">
            <fa-icon [icon]="faWorkPackIcon" class="propak-option-icon"></fa-icon>
            <span>ProPak</span>
          </button>
          <button type="button" class="dropdown-item" role="menuitem" (click)="launchAiAssistedProPak()">
            <span class="ai-sparkle-icon" aria-hidden="true" title="AI">
              <svg viewBox="0 0 24 24" width="16" height="16" focusable="false">
                <path fill="currentColor"
                  d="M11.2 3.4c.2-.7 1.2-.7 1.4 0l1.15 4.05c.08.28.3.5.58.58L18.4 9.2c.7.2.7 1.2 0 1.4l-4.07 1.15c-.28.08-.5.3-.58.58L12.6 16.4c-.2.7-1.2.7-1.4 0l-1.15-4.07c-.08-.28-.3-.5-.58-.58L5.4 10.6c-.7-.2-.7-1.2 0-1.4l4.07-1.17c.28-.08.5-.3.58-.58L11.2 3.4z" />
                <path fill="currentColor"
                  d="M18.35 2.55c.12-.4.68-.4.8 0l.45 1.55c.05.16.17.28.33.33l1.55.45c.4.12.4.68 0 .8l-1.55.45c-.16.05-.28.17-.33.33l-.45 1.55c-.12.4-.68.4-.8 0l-.45-1.55c-.05-.16-.17-.28-.33-.33l-1.55-.45c-.4-.12-.4-.68 0-.8l1.55-.45c.16-.05.28-.17.33-.33l.45-1.55z" />
                <rect x="3.2" y="16.9" width="3.4" height="1.5" rx="0.75" fill="currentColor" opacity="0.95" />
              </svg>
            </span>
            <span>New AI-Assisted ProPak</span>
          </button>
        </div>
      </div>
      <button class="ps-icon-btn" title="Readiness Form" (click)="openReadinessForm()"
        *ngIf="readinessSummary.Project.IsReadinessFormEnabled && readinessSummary.Priorities && readinessOverallComplete == 0">
        <ps-outline-icon name="plus"></ps-outline-icon>
      </button>
      <button class="ps-icon-btn" title="Readiness Form" (click)="openReadinessForm()"
        *ngIf="readinessSummary.Project.IsReadinessFormEnabled && readinessSummary.Priorities && readinessOverallComplete > 0">
        <ps-outline-icon name="pencil"></ps-outline-icon>
      </button>
    </div>
  </div>

  <summary-gauge [percent]="readinessOverallComplete" [display]="displayPercent" [statusLabel]="status.label"
    [badgeClass]="status.badgeClass" [gaugeColor]="status.gaugeColor"
    [isActive]="isActive" [playToken]="playToken"></summary-gauge>

  <div class="ps-date-grid">
    <div class="ps-date-cell" *ngFor="let priority of priorities" [ngClass]="'is-' + priorityTone(priority)">
      <span class="ps-date-icon">
        <ps-outline-icon [name]="priorityIcon(priority)"></ps-outline-icon>
      </span>
      <div>
        <div class="ps-date-label">{{ priority.PriorityName }}</div>
        <div class="ps-date-value">{{ priority.TaskCountTotal || 0 }}</div>
        <div class="ps-date-sub" *ngIf="priority.PercentComplete != null">{{ formatPriorityPercent(priority) }}</div>
      </div>
    </div>
  </div>
</div>

<div class="ps-card" *ngIf="priorities.length">
  <div class="ps-section-title">
    <span>Readiness Breakdown</span>
    <span class="ps-tip-host ps-info-host">
      <ps-outline-icon class="ps-info" name="info"></ps-outline-icon>
      <div class="ps-tip is-legend" role="tooltip">
        <div class="ps-tip-heading">Readiness score of each dimension by priority, scored as in the readiness form.</div>
        <span class="ps-tip-item" *ngFor="let row of legendRows">
          <span class="ps-tip-dot" [ngClass]="'is-' + row.tone"></span>{{ row.label }}
        </span>
      </div>
    </span>
  </div>

  <div class="ps-table-wrap">
    <table class="ps-table" [style.min-width.px]="tableMinWidth">
      <colgroup>
        <col class="col-status">
        <col class="col-count">
        <col class="col-dimension" *ngFor="let column of categoryColumns">
      </colgroup>
      <thead>
        <tr>
          <th>Status</th>
          <th>Count</th>
          <th *ngFor="let column of categoryColumns">{{ column }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let priority of priorities">
          <td>
            <span class="ps-status-cell">
              <span class="ps-dot" [ngClass]="'is-' + priorityTone(priority)"></span>
              {{ priority.PriorityName }}
            </span>
          </td>
          <td>{{ priority.TaskCountTotal || 0 }}</td>
          <td *ngFor="let column of categoryColumns">
            <div class="ps-cat-cell">
              <span class="ps-check" [ngClass]="'is-' + cellState(priority, column)">
                <ng-container [ngSwitch]="cellState(priority, column)">
                  <ps-outline-icon *ngSwitchCase="'pass'" name="check"></ps-outline-icon>
                  <ps-outline-icon *ngSwitchCase="'warn'" name="warning"></ps-outline-icon>
                  <ps-outline-icon *ngSwitchCase="'fail'" name="circle"></ps-outline-icon>
                </ng-container>
              </span>
              <div class="ps-cat-metrics ps-tip-host">
                <div class="ps-stack-bar">
                  <span class="is-complete" [style.width]="categoryPercent(priority, column, 'complete') + '%'"></span>
                  <span class="is-progress" [style.width]="categoryPercent(priority, column, 'inProgress') + '%'"></span>
                  <span class="is-incomplete" [style.width]="categoryPercent(priority, column, 'incomplete') + '%'"></span>
                </div>
                <div class="ps-cat-pct">{{ formatCategoryScore(priority, column) }}</div>
                <div class="ps-tip" role="tooltip">
                  <span class="ps-tip-item" *ngFor="let row of categoryTooltipRows(priority, column)">
                    <span class="ps-tip-dot" [ngClass]="'is-' + row.tone"></span>{{ row.label }} {{ row.value }}
                  </span>
                </div>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="ps-banner">
    <span class="ps-banner-icon">
      <ps-outline-icon name="file"></ps-outline-icon>
    </span>
    <div>
      <div class="ps-banner-title">{{ completeChecks }} / {{ totalChecks }} total checks complete</div>
      <div class="ps-banner-sub">Based on {{ dimensionCount }} readiness dimensions. Percentages are readiness scores; the bar splits tasks into fully, partly and not yet scored.</div>
    </div>
  </div>
</div>
